import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { MULTI_TENANT_REQUESTS_API_URL } = CONSTANT

const getMultiTenantRequests = async (
	clusterId: string
): Promise<{ status: number; body: Array<object> }> => {
	const response = await fetchWithAuthorizationHeader(
		`${MULTI_TENANT_REQUESTS_API_URL}?clusterId=${clusterId}`
	)
	if (response.status !== 200) {
		return {
			status: response.status,
			body: []
		}
	}
	return response.json()
}

export default getMultiTenantRequests
